import React from 'react';
import FiduciaLogo from '../../../assets/icons/FiduciaLogo';
import Frame from './components/Frame';
import { ILogo } from './interface';

function Logo(props: ILogo) {
  return (
    <Frame.Base onClick={props.onClick}>
      <FiduciaLogo color={props.color} size={props.width} />
    </Frame.Base>
  );
}

export default Logo;
